<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create payment/receipt record</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <!-- <v-text-field
                label="Supplier/Customer"
                placeholder="Supplier/Customer"
                :error-messages="customerErrors"
                v-model="payment.customer"
                hide-details="auto"
                @input="$v.payment.customer.$touch()"
                @blur="$v.payment.customer.$touch()"
                outlined
                dense
              ></v-text-field>-->
              <v-combobox
                :items="clients"
                :search-input.sync="searchClient"
                hide-details="auto"
                v-model="payment.customer"
                item-text="name"
                label="Supplier/Customer"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchClient }}</strong>". Press
                        <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-combobox
                :items="filteredCampaigns"
                :search-input.sync="searchCampaign"
                hide-details="auto"
                v-model="payment.campaign"
                label="Campaign Name"
                item-text="name"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchCampaign }}</strong>". Press
                        <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Reference No."
                placeholder="2019001467"
                v-model="payment.referenceNo"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="I/O Quote No."
                placeholder="IO-2019001521"
                v-model="payment.IOQuoteNo"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Voucher No."
                placeholder="RV2006002"
                v-model="payment.voucherNo"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Invoice No."
                placeholder="2019001521"
                v-model="payment.invoiceNo"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-textarea
                outlined
                name="description"
                v-model="payment.description"
                dense
                hide-details="auto"
                label="Description"
                placeholder="IO-2019001465 I Invoice 2019001467"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Debit"
                placeholder="3,000"
                prefix="$"
                v-model="payment.debit"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Credit"
                prefix="$"
                v-model="payment.credit"
                hide-details="auto"
                placeholder="500"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-textarea
                outlined
                name="remark"
                v-model="payment.remarks"
                dense
                hide-details="auto"
                label="Remarks"
                placeholder="Remarks"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="6">
              <v-combobox
                :items="sales"
                :search-input.sync="searchSale"
                hide-details="auto"
                v-model="payment.salePerson"
                item-text="name"
                label="Sale Person"
                dense
                multiple
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchSale }}</strong>". Press
                        <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="6" md="6">
              <v-menu
                ref="pickDate"
                v-model="pickDate"
                :close-on-content-click="false"
                :return-value.sync="payment.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="payment.date"
                    label="Date"
                    prepend-inner-icon="event"
                    outlined
                    dense
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="payment.date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="secondary" @click="pickDate = false">Cancel</v-btn>
                  <v-btn text color="secondary" @click="$refs.pickDate.save(payment.date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn
            color="green darken-1"
            :disabled="$v.payment.$invalid"
            text
            @click="doAction"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import paymentAPIs from './paymentAPIs';
import userAPIs from '../User/userAPIs';
import clientAPIs from '../Client/clientAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import config from '@/config';
export default {
  mixins: [validationMixin],
  props: {
    value: Boolean,
    mode: {
      type: String,
      default: 'new'
    },
    data: Object
  },
  validations: {
    payment: {
      customer: {
        required
      }
    }
  },
  data() {
    return {
      payment: {
        customer: null,
        referenceNo: null,
        voucherNo: null,
        description: null,
        debit: null,
        credit: null,
        date: null,
        remarks: null,
        IOQuoteNo: null,
        invoiceNo: null,
        salePerson: null
      },
      pickDate: false,
      userCs: [],
      sales: [],
      search: null,
      searchSale: null,
      searchCampaign: null,
      searchClient: null,
      campaigns: [],
      filteredCampaigns: [],
      clients: []
    };
  },
  computed: {
    customerErrors() {
      const errors = [];
      if (!this.$v.payment.customer.$dirty) return errors;
      !this.$v.payment.customer.required && errors.push(' This field is required.');
      return errors;
    },
    referenceNoErrors() {
      const errors = [];
      if (!this.$v.payment.referenceNo.$dirty) return errors;
      !this.$v.payment.referenceNo.required && errors.push('This field is required.');
      return errors;
    },
    ioQuoteNoErrors() {
      const errors = [];
      if (!this.$v.payment.IOQuoteNo.$dirty) return errors;
      !this.$v.payment.IOQuoteNo.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus() {
      return Object.values(config.campaignStatus).join();
    }
  },
  mounted() {
    this.fetchSales();
    this.fetchClient();
    this.fetchCampaigns();
  },
  watch: {
    data(newValue) {
      // Campaign was not associate to the payment
      // We have convert to string to show to UI
      if (newValue.campaign && !newValue.campaign.id) {
        newValue.campaign = newValue.campaign.name;
      }
      this.payment = Object.assign({}, newValue);
    },
    'payment.customer': function(newValue) {
      if (typeof newValue === 'object' && newValue.id) {
        this.filteredCampaigns = this.filterCampaignByClient(newValue.id);
      } else {
        this.filteredCampaigns = Object.assign([], this.campaignsFF);
      }
    }
  },
  methods: {
    doAction() {
      switch (this.mode) {
        case 'new':
          this.create();
          break;
        case 'edit':
          this.update();
          break;
      }
    },
    async fetchSales() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW);
        const users = resp.users;
        this.sales = users.map(user => {
          return {
            id: user.id,
            name: `${user.firstName} ${user.lastName}`
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    },
    async fetchClient() {
      try {
        const resp = await clientAPIs.getAllClients(true);
        const clients = resp.data;
        this.clients = clients.map(user => {
          return {
            name: user.name,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    filterCampaignByClient(clientID) {
      const campaigns = this.campaigns.filter(cmp => cmp.clientID === clientID);
      return campaigns;
    },
    async fetchCampaigns() {
      try {
        const resp = await campaignAPIs.paginate({});
        const campaigns = resp.campaigns;
        this.campaigns = campaigns.map(cmp => {
          return {
            name: cmp.name,
            id: cmp.id,
            clientID: cmp.clientID
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    close() {
      this.$emit('input');
    },
    constructData(input) {
      let data = Object.assign({}, input);
      if (typeof data.customer === 'string') {
        data.customer = {
          name: data.customer
        };
      }
      if (typeof data.campaign === 'string') {
        data.campaign = {
          name: data.campaign
        };
      }
      return data;
    },
    async create() {
      try {
        const data = this.constructData(this.payment);
        await paymentAPIs.createPaymentOrReceipt(data);
        this.$swal({
          text: 'New payment record is created',
          type: 'success'
        });
        this.$emit('created');
        this.$emit('input');
      } catch (error) {
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async update() {
      try {
        const data = this.constructData(this.payment);
        const id = data.id;
        if (!id) {
          this.$swal({
            text: 'Record id not found',
            type: 'warning'
          });
          return;
        }
        await paymentAPIs.updatePaymentOrReceipt(id, data);
        this.$swal({
          text: 'New payment record is updated',
          type: 'success'
        });
        this.$emit('created');
        this.$emit('input');
      } catch (error) {
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// CreatePaymentRecordModal.vue?bce3ee28